<template>
  <div id="app"></div>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'PowerAppV6',

    data: function() {
      return {
        app: null
      }
    },

    computed: {
      isDev() {
        return this.$store.getters.getCurrentEnv == 'dev'
      }
    },

    methods: {
      setup() {
        const FloatingSession = Vue.extend({
          template: `<div class="floatingSession">{{user.Entity.name}}</div>`,
          props: ['user']
        }); // Create constructor

        const instance = new FloatingSession({
          propsData: {
            user: this.$store.getters.getClaims
          }
        }); 

        instance.$mount();
        document.body.appendChild(instance.$el);
      }
    },

    async mounted() {
      const popup = this.$loadingPopup()
      this.setup()

      try {
        let { data: app } = await this.$http.get(`/luma/appservice/app/${this.$route.params.id}/settings`)
        
        // resolve 
        let version = app.public_version
        if (this.isDev)
          version = app.dev_version

        const { data } = await this.$http.get(`/luma/appservice/bundle/${app.project_uuid}/${app.name}/${version}/main.bundle.js?v=${new Date().getTime()}`, {
          responseType: 'text'
        });

        const script = document.createElement("script");
        script.textContent = data;
        document.body.appendChild(script);

      }  catch(err) {
        this.$debugLog(err)
        this.$mainDialog.msgBoxOk("Failed to fetch app.")
      } finally {
        popup.hide()
      }

        
    }
}
</script>

<style>
.floatingSession {
  position: fixed;
  left: 15px;
  top: 15px;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #6c80ff, #764ba2);
  border-radius: 100px;
  text-align: center;
}
</style>